import { jsx } from "react/jsx-runtime";
import { useMemo } from "react";
import PropTypes from "prop-types";
import { SegmentedControlWrapper } from "./segmented-control.styles.es.js";
import { segmentedControlContext } from "./segmented-control-context.es.js";
const { Provider } = segmentedControlContext;
const propTypes = {
  children: PropTypes.node.isRequired,
  disabled: PropTypes.bool,
  magnitude: PropTypes.oneOf(["medium", "small"]),
  onChange: PropTypes.func,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  widthMode: PropTypes.oneOf(["fill-container", "fit-content"])
};
const defaultProps = {
  disabled: false,
  magnitude: "medium",
  onChange: void 0,
  value: void 0,
  widthMode: "fit-content"
};
const SegmentedControl = ({
  children,
  disabled,
  magnitude,
  onChange,
  value,
  widthMode
}) => {
  const contextValue = useMemo(
    () => ({ disabled, magnitude, setValue: onChange, value, widthMode }),
    [disabled, magnitude, onChange, value, widthMode]
  );
  return /* @__PURE__ */ jsx(Provider, { value: contextValue, children: /* @__PURE__ */ jsx(SegmentedControlWrapper, { $disabled: disabled, $widthMode: widthMode, children }) });
};
SegmentedControl.propTypes = propTypes;
SegmentedControl.defaultProps = defaultProps;
export {
  SegmentedControl
};
